import { Link } from 'react-router-dom';
import { COMPANY, copyrightLine } from '../lib/company';

const LINKS = [
  { to: '/welcome', label: 'About' },
  { to: '/faq', label: 'FAQ' },
  { to: '/contact', label: 'Contact' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms & Conditions' },
];

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <span className="site-footer-product">{COMPANY.product}</span>
          <span className="site-footer-tagline">by {COMPANY.groupName}</span>
        </div>
        <nav className="site-footer-links" aria-label="Footer">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to}>
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="site-footer-legal">{copyrightLine()}</div>
    </footer>
  );
}
